class EdubimValidateCheckout extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector("input[type='checkbox']");

        // default state
        document.querySelectorAll("button[type='submit'][name='checkout']").forEach(button => {
            button.disabled = true;
        })

        this.input.addEventListener("change", () => {
            console.log("Change event on validate checkout")
            const isChecked = this.input.checked;

            document.querySelectorAll("button[type='submit'][name='checkout']").forEach(button => {
                button.disabled = !isChecked;
            })
        })
    }




}

customElements.define("edubim-validate-checkout", EdubimValidateCheckout)

class EdubimCustomerType extends HTMLElement {
    constructor() {
        super();

        this.inputs = this.querySelectorAll("input[type='radio']");

        const checked = this.querySelector("input[type='radio']:checked");
        const desiredValue = checked && checked.value === "business" ? "true" : "false";
        const currentValue = this.dataset.currentValue || "";

        if (currentValue !== desiredValue) {
            this.updateCartAttribute(desiredValue);
        }

        this.inputs.forEach(input => {
            input.addEventListener("change", () => {
                if (!input.checked) return;
                const value = input.value === "business" ? "true" : "false";
                this.updateCartAttribute(value);
            });
        });
    }

    updateCartAttribute(value) {
        return fetch(`${Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                attributes: { require_company: value }
            })
        }).then(() => {
            this.dataset.currentValue = value;
        }).catch(err => {
            console.error("Failed to update require_company cart attribute", err);
        });
    }
}

customElements.define("edubim-customer-type", EdubimCustomerType)